export default "{\n  project(name: \"GraphQL\") {\n    tagline\n  }\n}\n"